import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconColumns$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconColumns extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd57b972e2b15d79ce07c1fb221790f849b69a501', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '73d48eadd6c222577b36fb6f17e7443a519b279b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'fb6eb7ecef12a90bf6bb6ed0e00ecd9a33842021', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M4.5 4a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5zm8 1.5h-3v11h3zm1.5 0v11h2.5v-11zm-8.5 0H8v11H5.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-columns", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-columns"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-columns":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconColumns$1);
            }
            break;
    } });
}

const CosmosIconColumns = CosmosIconColumns$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconColumns, defineCustomElement };
